import React from 'react';
import PropTypes from 'prop-types';
import {
  AlgorithmicLists,
} from '@resy/ui-kitchen';
import './DeltaWifiAlgorithmicLists.scss';

const DeltaWifiAlgorithmicLists = (props) => (
  <section className="DeltaWifiAlgorithmicLists__section">
    <div className="container"><AlgorithmicLists {...props} isDeltaWifi /></div>
  </section>
);

DeltaWifiAlgorithmicLists.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func.isRequired,
  }).isRequired,
  locationSlug: PropTypes.string.isRequired,
  selectedDate: PropTypes.string.isRequired,
  selectedPartySize: PropTypes.string.isRequired,
};

export default DeltaWifiAlgorithmicLists;
